export const GET_MASTER_DATA = 'GET_MASTER_DATA'
export const GET_MASTER_DATA_TABLE = 'GET_MASTER_DATA_TABLE'
